module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg2-0a0269127a8ae91d1d9e9d2d4e985ffd.svg";